import type { ContentObject } from '../lib/flotiq-client/types/api-response';

import { useQuery } from '@tanstack/react-query';

import { getContentObject } from '../lib/flotiq-client';
import { getQueryCacheKey } from '../lib/queryClientHelpers';

import useSelectedSpace from './useSelectedSpace';
import useToken from './useToken';

export const usePublicVersion = (
  contentObject?: ContentObject | null,
): ContentObject | null => {
  const jwt = useToken();
  const { space } = useSelectedSpace();

  const type = contentObject?.internal?.contentType;
  const id = contentObject?.id;
  const status = contentObject?.internal?.status;

  const isAlreadyPublic = status === 'public';
  const shouldFetch = status === 'modified' && !!type && !!id && !!jwt;

  const params = { contentTypeName: type, id };

  const { data: response } = useQuery({
    queryKey: getQueryCacheKey(
      'content-objects',
      'public',
      params,
      'entity',
      space,
    ),
    queryFn: async ({ signal }) =>
      getContentObject(jwt, space, params, { signal, public: true }),
    enabled: shouldFetch,
    staleTime: 0,
    gcTime: 5 * 60 * 1000,
    retry: 0,
  });

  if (isAlreadyPublic) return contentObject ?? null;
  return response?.ok ? response.body : null;
};
